<template>
    <div class="exemption-status-badge"
         v-if="statusLabel">
        <b-badge :variant="badgeVariant" class="m-1">
            {{ statusLabel }}
            <span v-if="grantedThru">
                - {{ grantedThru }}
            </span>
        </b-badge>
    </div>
</template>

<script>
import Exemption from '@/models/Exemption'

export default {
    name: 'ExemptionStatusBadge',
    props: {
        // HACK: this can be a label in some cases, e.g. 'Denied' instead of 'DENIED' (see ExemptionView)
        status: String,
        grantedThru: String
    },
    computed: {
        statusLabel () {
            const label = Exemption.getStatusLabel(this.status)
            if (label) {
                return label
            } else {
                return this.status
            }
        },
        badgeVariant () {
            const variant = Exemption.getStatusBadgeVariant(this.status)
            if (variant) {
                return variant
            } else {
                return Exemption.getStatusBadgeVariantByLabel(this.status)
            }
        },
    }
}
</script>

<style lang="scss">
.exemption-status-badge {
    display: inline-block;
}
</style>
